var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPersonRacer)?_c('router-link',{staticClass:"link-person",class:{
                 'text-primary': _vm.gender !== 'z',
                 'text-danger': _vm.gender === 'z'
             },attrs:{"to":{name: 'person', params: {person: _vm.person}}},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_vm._v("\n    "+_vm._s(_vm.person)+"\n")]):_c('span',[_vm._v("\n    "+_vm._s(_vm.person)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }